export const getAppName = (): string | undefined => process.env.APP_NAME;
